import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  () => ({
    wrapper: {
      width: '100%',
    },
    container: {
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }),
  { name: 'GenContentList' },
);

export default useStyles;
